export default "__VITE_ASSET__Dp4L3Rt1__"